/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VesselPosition
 */
export interface VesselPosition {
    /**
     * 
     * @type {any}
     * @memberof VesselPosition
     */
    latitude?: any | null;
    /**
     * 
     * @type {any}
     * @memberof VesselPosition
     */
    longitude?: any | null;
    /**
     * 
     * @type {any}
     * @memberof VesselPosition
     */
    sog?: any | null;
    /**
     * 
     * @type {any}
     * @memberof VesselPosition
     */
    cog?: any | null;
    /**
     * 
     * @type {any}
     * @memberof VesselPosition
     */
    timestamp?: any | null;
}

/**
 * Check if a given object implements the VesselPosition interface.
 */
export function instanceOfVesselPosition(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function VesselPositionFromJSON(json: any): VesselPosition {
    return VesselPositionFromJSONTyped(json, false);
}

export function VesselPositionFromJSONTyped(json: any, ignoreDiscriminator: boolean): VesselPosition {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'latitude': !exists(json, 'latitude') ? undefined : json['latitude'],
        'longitude': !exists(json, 'longitude') ? undefined : json['longitude'],
        'sog': !exists(json, 'sog') ? undefined : json['sog'],
        'cog': !exists(json, 'cog') ? undefined : json['cog'],
        'timestamp': !exists(json, 'timestamp') ? undefined : json['timestamp'],
    };
}

export function VesselPositionToJSON(value?: VesselPosition | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'latitude': value.latitude,
        'longitude': value.longitude,
        'sog': value.sog,
        'cog': value.cog,
        'timestamp': value.timestamp,
    };
}

